<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import URL from '@/views/newmis36/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    let status = {"0":"未启用","1":"启用"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        created(){
            this.formData.cols = [
                { title: window.$t('txmis.coin.symbol'), field: 'symbol'},
                { title: window.$t('txmis.coin.ip'), field: 'ip'},
                {click:window.$t('txmis.bt.search')},
                {click:window.$t('txmis.bt.add')},
            ]
        },
        methods: {
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
                if (clickName == "update"){
                    this.$refs.childUpdate.open(row);
                }else if (clickName == "delete"){
                    this.dataChanage(URL.coin.delete,{symbols:row.symbol},res =>{
                        if (res.code == 0){
                            this.$message.success("suc");
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('txmis.bt.search') == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if(window.$t('txmis.bt.add') == clickName){
                    this.$refs.childUpdate.open();
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model){
                //根据是否包含id更新还是添加
                this.dataChanage(URL.coin.edit,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                deleteIds:"",
                queryData:{},
                /*新增或更新*/
                updateData:{
                    cols:[
                        { title: window.$t('txmis.coin.code'), field: 'code',required:true},
                        { title: window.$t('txmis.coin.symbol'), field: 'symbol',required:true},
                        { title: window.$t('txmis.coin.ip'), field: 'ip',required:true},
                        { title: window.$t('txmis.coin.depthQtyDigitsLength'), field: 'depthQtyDigitsLength',required:true},
                        { title: window.$t('txmis.coin.depthPriceDigitsLength'), field: 'depthPriceDigitsLength',required:true},
                        { title: window.$t('txmis.coin.depthPercentQty'), field: 'depthPercentQty',required:true},
                        { title: window.$t('txmis.coin.depthPercentPrice'), field: 'depthPercentPrice',required:true},
                        { title: window.$t('txmis.coin.depthQtyMin'), field: 'depthQtyMin',required:true},
                        { title: window.$t('txmis.coin.tradeQtyMin'), field: 'tradeQtyMin',required:true},
                        { title: window.$t('txmis.coin.depthQtyRandomTimes'), field: 'depthQtyRandomTimes',required:true},
                        { title: window.$t('txmis.coin.tradeQtyRandomTimes'), field: 'tradeQtyRandomTimes',required:true},
                        { title: window.$t('txmis.coin.status'), field: 'status',type:2,optionList:status,isNumber:true},
                    ],
                },
                /*from查询表单*/
                formData:{
                  hasLable: true,
                  cols:[
                    { title: window.$t('symbol'), field: 'symbol'},
                    { title: window.$t('ip'), field: 'ip'},
                    {click:window.$t('txmis.bt.search')},
                    {click:window.$t('txmis.bt.down')}
                  ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.coin.list, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                      { title: window.$t('txmis.coin.code'), field: 'code'},
                      { title: window.$t('txmis.coin.symbol'), field: 'symbol'},
                      { title: window.$t('txmis.coin.ip'), field: 'ip'},
                      { title: window.$t('txmis.coin.depthQtyDigitsLength'), field: 'depthQtyDigitsLength'},
                      { title: window.$t('txmis.coin.depthPriceDigitsLength'), field: 'depthPriceDigitsLength'},
                      { title: window.$t('txmis.coin.depthPercentQty'), field: 'depthPercentQty'},
                      { title: window.$t('txmis.coin.depthPercentPrice'), field: 'depthPercentPrice'},
                      { title: window.$t('txmis.coin.depthQtyMin'), field: 'depthQtyMin'},
                      { title: window.$t('txmis.coin.tradeQtyMin'), field: 'tradeQtyMin'},
                      { title: window.$t('txmis.coin.depthQtyRandomTimes'), field: 'depthQtyRandomTimes'},
                      { title: window.$t('txmis.coin.tradeQtyRandomTimes'), field: 'tradeQtyRandomTimes'},
                      { title: window.$t('txmis.coin.status'),  field: 'status',render:(data,full)=> {
                          return status[data] || "";
                        }},
                      {field:window.$t('txmis.bt.edit'),title:window.$t('txmis.bt.operation'),size:"mini",click:"update",type:"primary",icon:"el-icon-edit"},
                      {field:window.$t('txmis.bt.delete'),title:window.$t('txmis.bt.operation'),size:"mini",click:"delete",type:"primary",icon:"el-icon-delete"},
                    ]
                }
            }
        }
    }
</script>
